<template>
	<div class="news-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home">
				<i class="n el-icon-s-home"></i>
				首页
			</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/news' }">资讯</el-breadcrumb-item>
			<!-- <el-breadcrumb-item class="path-help">帮助详情</el-breadcrumb-item> -->
		</el-breadcrumb>
		<div class="news" v-loading="loading" v-if="hidenews">
			<div class="content">
				<div class="left-column">
					<div class="detail" v-if="detail">
						<h1>{{detail.title}}</h1>
						<div class="account">
							<span>分类:
								<router-link :to="`/news-list-${detail.cat_id}`" >{{detail.category.name||''}}</router-link>
							</span>
							<span>作者:{{detail.author|| $config.title}}</span>
							<span>点击:{{detail.hits}}</span>
							<span>发布时间:{{detail.create_time}}</span>
						</div>
						<div class="content" v-html="content()"></div>
					</div>
					<div class="other">
						<sub-title title="相关资讯"></sub-title>
						<list1 v-if="detail" :list="detail.related"></list1>
					</div>
				</div>
				<div class="right-column">
					<sidebar></sidebar>
				</div>
			</div>
		</div>
		<ErroVue v-if="HideErro"/>
	</div>
</template>

<script>
import { helpDetail } from '@/api/cms/help';
import {
	newsList,
	newsCat,
	newsDetail
} from "@/api/cms/news";
import sidebar from "./components/sidebar"
import SubTitle from "@/components/SubTitle"
import DescText from "@/components/DescText"
import list1 from "./components/list1"
import ErroVue from "@/views/index/error"
export default {
	name: 'detail_detail',
	components: {
		sidebar,
		SubTitle,
		list1,
		ErroVue
	},
	data: () => {
		return {
			id:null,
			loading: true,
			detail:null,
			hidenews:true,
			HideErro:false,
			seo:{
				title:"",
				keywords:"",
				description:""
			}
		};
	},
	// metaInfo: {
	// 	title: this.seo.title,
	// 	keywords:this.seo.keywords,
	// 	description:this.seo.description,
	// 	titleTemplate: '%s-行业资讯-中械云配',
	// 	htmlAttrs: {
	// 		lang: 'zh'
	// 	},
	// 	// script: [{innerHTML: 'console.log("hello hello!")', type: 'text/javascript'}],
	// 	// __dangerouslyDisableSanitizers: ['script']
	// },
	created() {
		this.id = this.$route.params.pathMatch
		this.getDetail();
	},
	mounted() {
		this.id = this.$route.params.pathMatch
		this.loading = true;
		this.getDetail();
		//设置seopage 渲染时间加长
		// this.$util.seopage(1);
		// console.log('9999999999999999',this.$route)
	},
	watch: {
		$route(curr) {
			this.id = curr.params.pathMatch;
			// console.log(22222);
			this.loading = true;
			this.getDetail();
		},
		seo: {
		    handler: function(e) {
				// '-'+this.detail.category.name+
				// document.getElementsByTagName("title")[0].innerText = e.title +'-中械云配';
				// document.getElementsByTagName("keywords")[0].innerText = e.keywords;
				// document.getElementsByTagName("description")[0].innerText = e.description;
				// document.title = this.seo.title
				// document.keywords = this.seo.keywords
				// document.description = this.seo.description
		    },
		    immediate: true,
		    deep: true
		}
	},
	methods: {
		getDetail() {
			newsDetail({
				id: this.id
			}).then(res => {
				if (res.code == 0) {
					if (res.data) {
						this.loading = false;
						this.detail = res.data;
						this.seo.title = res.data.title;
						this.seo.keywords = res.data.keywords;
						this.seo.description = res.data.description;
						
						// this.$util.seo(this.seo)
					} else {
						// console.log(333)
						
						// this.$router.push({ path: '/cms/help' });
					}
				}
			}).catch(err => {
				this.loading = false;
				// this.$message.error(err.message);
				this.hidenews=false;
				this.HideErro=true;
				

			});
		},
		content(){
			let c = this.detail.content || '';
			c= c.replace(/<img[^>]*>/gi,function(match,capture){
				match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
				return match;
			});
			// console.log(111,c)
			// newContent = newContent.replace(/\<img[^>]*>/gi, '2222222222222');
//         	newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
//         		match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
//         		return match;
//         	});
			
        	c = c.replace(/<br[^>]*\/>/gi, '<br>');
//         	newContent = newContent.replace(/\<img[^>]*>/gi, '');
			// console.log(1211,c)
        	c = c.replace(/<p[^>]*>/gi,'<p>')
			// console.log(133311,c)
			// newContent = newContent.replace(/(<([^>]+)>)/ig, '');
			// c = c.replace(/\s+/g,"");
			// console.log(4111,c)
			return c;
			// ()detail.content
		}
	}
};
</script>
<style lang="scss" scoped>
.news-wrap {
	background: #ffffff;
	.path {
		padding: 15px 0;
	}
	::v-deep.error-wrap{
		position:relative;
		transform: translate(0%,0%);
		top: 0;
		left:0;
	}
}
	
.news {
	padding-bottom: 20px;
	.content{
		display: flex;
		flex-flow: wrap;
		width: 1210px;
		margin-bottom: 20px;
		.left-column{
			width: 900px;
			// flex: 1;
			display: block;
			.detail{
				display: block;
				overflow: hidden;
				h1{
					text-align: center;
				}
				.account{
					margin: 15px 0 0 0 ;
					text-align: center;
					span{
						margin:0  10px;
					}
				}
				.content{
					margin: 15px 0 0 0 ;
					display: block;
					overflow: hidden;
					width: 100%;
					
				}
				
			}
			
		}
		.right-column{
			// width: 260px;
			flex: 1;
			padding-left: 20px;
			overflow: hidden;
		}
	}
}
</style>
